import request from "@/global/request/axios";
import API from "@/global/request/api";

export const applyService = {
  applySchool(params: {}) {
    return request.post(API.applySchool, params);
  },
  applyCompany(params: {}) {
    return request.post(API.applyCompany, params);
  },
  getSchoolInviteInfo(code: string) {
    return request.get(API.schoolInvite(code));
  },
  agreeSchoolInvite(code: string, params: CompanyInfo | InviteParam) {
    return request.post(API.schoolInvite(code), params);
  },
};
